"use client";

import { useState } from "react";
import Image from "next/image";
import WebLogo from "@/components/common/WebLogo";

export default function ComingSoon() {


  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex flex-col items-center justify-center p-4">
      <div className="max-w-3xl w-full text-center space-y-8">
        {/* Logo */}
        <div className="mb-8">
        <WebLogo />
        </div>

        {/* Main Content */}
        <div className="space-y-4">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900">
            Coming Soon
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-2xl mx-auto">
            We&apos;re working hard to bring you something amazing. Stay tuned!
          </p>
        </div>

        {/* Social Links */}
        <div className="pt-8">
          <div className="flex justify-center space-x-6">
            {[
              { name: "Twitter", href: "#", icon: "ri-twitter-fill" },
              { name: "Facebook", href: "#", icon: "ri-facebook-fill" },
              { name: "Instagram", href: "#", icon: "ri-instagram-fill" },
              { name: "LinkedIn", href: "#", icon: "ri-linkedin-fill" },
            ].map((social) => (
              <a
                key={social.name}
                href={social.href}
                className="text-gray-400 hover:text-gray-500"
              >
                <span className="sr-only">{social.name}</span>
                <i className={`${social.icon} text-2xl`}></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}